// eslint-disable-next-line no-restricted-imports
import dayjs from '../dayjsConfig';

const getDayJsDate = (value: string | number | Date, timeZone?: string) => dayjs.tz(value, timeZone);

export default getDayJsDate;
